import React from "react";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import {  Col } from "reactstrap";
import PropTypes from 'prop-types';

import './style.scss'; 

function ServicesBox ({title, description}) {
    return (
        <Col xs={12} md={3}>
            <div className="services-box">
                <FontAwesomeIcon className="services-chevron-icon" icon={faChevronRight}/>
                <h3 className="heading-3">{title}</h3>
                <p className="body-text">{description}</p>
            </div>
        </Col>
    )
}

ServicesBox.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default ServicesBox;
